import React, { useCallback, useEffect, useState } from "react";
import { toggleForm } from "../../../redux/features/general";
import { useDispatch } from "react-redux";

function Console({ setSearch, search }) {
  let dispatch = useDispatch();
  const [debouncedSearch, setDebouncedSearch] = useState(search || "");

  // Debounce logic: Updates search state after 500ms delay
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(debouncedSearch);
    }, 500);

    return () => clearTimeout(handler);
  }, [debouncedSearch, setSearch]);

  const handleSearch = useCallback((e) => {
    setDebouncedSearch(e.target.value);
  }, []);
  return (
    <div className="flex items-center gap-3">
      <input
        className="focus:outline-primary border w-full p-2 rounded-md"
        placeholder="Search by title..."
        name="search"
        onChange={handleSearch}
        value={debouncedSearch}
      />
    </div>
  );
}

export default Console;
